// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"questionBox_questionBox__20aM5","questionText":"questionBox_questionText__A8Oe2","booleanClass":"questionBox_booleanClass__3NbO4"};